import React, { useContext } from 'react';
export var EnvironmentContext = /*#__PURE__*/React.createContext({});
export var EnvironmentHooksProvider = function EnvironmentHooksProvider(_ref) {
  var env = _ref.env,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(EnvironmentContext.Provider, {
    value: {
      env: env
    }
  }, children);
};
export var useEnv = function useEnv() {
  return useContext(EnvironmentContext);
};